import React, { useState, useEffect } from 'react';
import { Button, Alert, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { getuserlogged, getuserperiodlogged } from '../services/login';
import { listahorarios, mostrarhorario, eliminarhorario } from '../services/horarios';
import Error from './Error';
import { useHistory } from "react-router-dom";
import { urlbase } from '../utils/utils';
import { kaReducer, Table } from "ka-table";
import { DataType, SortingMode, SortDirection } from "ka-table/enums";
import Moment from 'react-moment';
import 'moment-timezone';


function Listarhorarios(props) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [idschedule, setIdschedule] = useState('');

    let history = useHistory();
    const [errormensaje, setErrormensaje] = useState([]);

    //const [errormensaje,setErrormensaje] = useState([]);
    const [info, setInfo] = useState([]);
    const [usuario, setUsuario] = useState('');
    const [periodo, setPeriodo] = useState('');
    //const [tiempoconsulta,setTiempoconsulta] = useState(Date.now());
    

    const showschedule = (horario, nrcs) => {
        mostrarhorario(nrcs, periodo).then(
            res => {
                props.setHorario(horario);
                props.setSelectcursos(res.data);
            }
        ).catch(
            errorcatch
        );
    }

    /*function listadehorarios(){
        listahorarios(usuario,periodo).then(
            res=>{
                //console.log(res.data);
                tablePropsInit.data=res.data;
                changeTableProps(tablePropsInit);
                var infodb=res.data;
                infodb.map((data,index)=>{
                    data['HORARIO']=index+1;
                    return(infodb);
                })
                setInfo(infodb);                        
            }                
        ).catch(
            errorcatch   
        ); 
    }*/

    const modaldeleteschedule = (idhorario) => {
        setShow(true);
        setIdschedule(idhorario);
    }

    const deleteschedule = (idhorario) => {
        //console.log(idhorario);
        //console.log(usuario);
        //console.log(periodo);
        eliminarhorario(usuario, idhorario, periodo).then(
            res => {
                props.setHorario('');
                props.setSelectcursos('');
                listahorarios(usuario, periodo).then(
                    res => {
                        //console.log(res.data);
                        tablePropsInit.data = res.data;
                        changeTableProps(tablePropsInit);
                        var infodb = res.data;
                        infodb.map((data, index) => {
                            data['HORARIO'] = index + 1;
                            return (infodb);
                        })
                        setInfo(infodb);
                        setShow(false);
                    }
                ).catch(
                    errorcatch
                );
            }
        ).catch(
            errorcatch
        );
    }

    

    function errorcatch(error) {
        //console.log(error);
        if (error.response.status === 500) {
            setErrormensaje(Error(error.response.data.mensaje));
        }
        if (error.response.status === 403) {
            setErrormensaje(Error(error.response.data.mensaje));
            setTimeout(() => history.push(urlbase), 5000);
        }
    }

    const tablePropsInit = {
        columns: [
            {
                dataType: DataType.String,
                key: "HORARIO",
                style: { width: 50 },
                title: "Horario"
            },
            /*{
                dataType: DataType.Number,
                key: "PERIODO",
                sortDirection: SortDirection.Ascend,
                style: { width: 40 },
                title: "Periodo"
            },*/
            {
                dataType: DataType.Date,
                key: "FECHA_CREACION",
                sortDirection: SortDirection.Descend,
                style: { width: 60 },
                title: "Fecha Creacion"
            },
            {
                key: "ID_HORARIO",
                style: { width: 30 },
                title: ""
            },
            {
                key: "NRCS",
                style: { width: 30 },
                title: ""
            }
        ],
        data: info,
        rowKeyField: "ID_HORARIO",
        sortingMode: SortingMode.Single
    };

    const [tableProps, changeTableProps] = useState(tablePropsInit);
    const dispatch = action => {
        changeTableProps(prevState => kaReducer(prevState, action));
    };

    useEffect(() => {
        var usuario = getuserlogged();
        var periodo = getuserperiodlogged();
        //periodo = '202110'
        setPeriodo(periodo);
        setUsuario(usuario);
        listahorarios(usuario, periodo).then(
            res => {
                //console.log(res.data);
                tablePropsInit.data = res.data;
                changeTableProps(tablePropsInit);
                var infodb = res.data;
                infodb.map((data, index) => {
                    data['HORARIO'] = index + 1;
                    return (infodb);
                })
                setInfo(infodb);
            }
        ).catch(
            errorcatch
        );
    }, []);

    return (
        <div>
            {errormensaje !== "" && errormensaje}
            <h2>Mis Horarios</h2>
            {info.length === 0 &&
                <Alert variant='primary'>
                    No tienes horarios guardados.
                </Alert>
            }
            
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Eliminar horario</Modal.Title>
                </Modal.Header>
                <Modal.Body>¿Estás seguro de que quieres eliminar el horario?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                    <Button variant="primary" onClick={() => deleteschedule(idschedule)}>
                        Continuar
                    </Button>
                </Modal.Footer>
            </Modal>

            {info.length > 0 &&
                <Table
                    {...tableProps}
                    childComponents={{
                        cellText: {
                            content: (propstable) => {
                                //console.log(props.rowData);
                                if (propstable.column.key === 'HORARIO') {
                                    return (<span>{'Horario ' + propstable.rowData.HORARIO}</span>)
                                }
                                if (propstable.column.key === 'FECHA_CREACION') {
                                    return (
                                        <Moment format="DD/MM/YYYY HH:mm">
                                            {propstable.rowData.FECHA_CREACION}
                                        </Moment>
                                    )
                                }
                                if (propstable.column.key === 'ID_HORARIO') {
                                    return (
                                        <Button variant="danger" className="deleteschedule" onClick={() => modaldeleteschedule(propstable.rowData.ID_HORARIO)}>
                                            <FontAwesomeIcon icon={faTrashAlt} />
                                        </Button>
                                    )
                                }
                                if (propstable.column.key === 'NRCS') {
                                    return (
                                        <Button variant="primary" className="displayschedule" onClick={() => showschedule('Horario ' + propstable.rowData.HORARIO, propstable.rowData.NRCS)}>
                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                        </Button>
                                    )
                                }
                            }
                        }
                    }}
                    dispatch={dispatch}
                />
            }
        </div>
    )
}
export default Listarhorarios;